export default {
  users: (state) => {
    return state.users;
  },
  total: (state) => {
    return state.total;
  },
  roles: (state) => {
    return state.roles;
  },
  role: (state) => {
    return state.role;
  },
  unit: (state) => {
    return state.unit;
  },
  firstName: (state) => {
    return state.firstName;
  },
  lastName: (state) => {
    return state.lastName;
  },
  username: (state) => {
    return state.username;
  },
  password: (state) => {
    return state.password;
  },
  confirm: (state) => {
    return state.confirm;
  },
  mobile: (state) => {
    return state.mobile;
  },
  dateOfBirth: (state) => {
    return state.dateOfBirth;
  },
  mobileCountryId: (state) => {
    return state.mobileCountryId;
  },
  spouseFirstName: (state) => {
    return state.spouseFirstName;
  },
  spouseLastName: (state) => {
    return state.spouseLastName;
  },
  spouseNationalCode: (state) => {
    return state.spouseNationalCode;
  },
  spouseCountryId: (state) => {
    return state.spouseCountryId;
  },
  spouseIdentityCode: (state) => {
    return state.spouseIdentityCode;
  },
  fatherName: (state) => {
    return state.fatherName;
  },
  nationalCode: (state) => {
    return state.nationalCode;
  },
  otherCode: (state) => {
    return state.otherCode;
  },
  expiryDateOfIdentityDocument: (state) => {
    return state.expiryDateOfIdentityDocument;
  },
  typeOfIdentificationDocument: (state) => {
    return state.typeOfIdentificationDocument;
  },
  typeOfIdentificationDocuments: (state) => {
    return state.typeOfIdentificationDocuments;
  },
  forefatherName: (state) => {
    return state.forefatherName;
  },
  mobiles: (state) => {
    return state.mobiles;
  },
  country: (state) => {
    return state.country;
  },
  city: (state) => {
    return state.city;
  },
  province: (state) => {
    return state.province;
  },
  // birthProvince: state => {
  //     return state.birthProvince;
  // },
  birthCity: (state) => {
    return state.birthCity;
  },
  placeOfBirthCityForForeign: (state) => {
    return state.placeOfBirthCityForForeign;
  },
  gender: (state) => {
    return state.gender;
  },
  genders: (state) => {
    
    return state.genders;
  },
  roleFilter: (state) => {
    return state.roleFilter;
  },
  maritalStatus: (state) => {
    return state.maritalStatus;
  },
  referralWays: (state) => {
    return state.referralWays;
  },
  socialNetworks: (state) => {
    return state.socialNetworks;
  },
  referralWay: (state) => {
    return state.referralWay;
  },
  referrerName: (state) => {
    return state.referrerName;
  },
  referrerUser: (state) => {
    return state.referrerUser;
  },
  referrerUsers: (state) => {
    return state.referrerUsers;
  },
  referrerAddress: (state) => {
    return state.referrerAddress;
  },
  referrerNationalCode: (state) => {
    return state.referrerNationalCode;
  },
  maritalStatuses: (state) => {
    return state.maritalStatuses;
  },
  addresses: (state) => {
    return state.addresses;
  },
  addressTypes: (state) => {
    return state.addressTypes;
  },
  addressCities: (state) => {
    return state.addressCities;
  },
  email: (state) => {
    return state.email;
  },
  phones: (state) => {
    return state.phones;
  },
  userToEdit: (state) => {
    return state.userToEdit;
  },
  userAddService: (state) => {
    return state.userAddService;
  },
  serviceToAdd: (state) => {
    return state.serviceToAdd;
  },
  usersToAdd: (state) => {
    return state.usersToAdd;
  },
  usersToAddIndex: (state) => {
    return state.usersToAddIndex;
  },
  spouses: (state) => {
    return state.spouses;
  },
  spousesToDelete: (state) => {
    return state.spousesToDelete;
  },
  foreignUserToSearch: (state) => {
    return state.foreignUserToSearch;
  },
  searchedForeigners: (state) => {
    return state.searchedForeigners;
  },
  userServiceEdit: (state) => {
    return state.userServiceEdit;
  },
  userProfile: (state) => {
    return state.userProfile;
  },
  birthCertificateId: (state) => {
    return state.birthCertificateId;
  },
  medicalSystemNumber: (state) => {
    return state.medicalSystemNumber;
  },
  startDateAtWork: (state) => {
    return state.startDateAtWork;
  },
  endDateAtWork: (state) => {
    return state.endDateAtWork;
  },
  completionDateOfMedicalLicense: (state) => {
    return state.completionDateOfMedicalLicense;
  },
  officeLicenseNumber: (state) => {
    return state.officeLicenseNumber;
  },
  statusOfMemberships: (state) => {
    return state.statusOfMemberships;
  },
  facultyStatus: (state) => {
    return state.facultyStatus;
  },
  accountNumber: (state) => {
    return state.accountNumber;
  },
  iBAN: (state) => {
    return state.iBAN;
  },
  accountType: (state) => {
    return state.accountType;
  },
  cooperationType: (state) => {
    return state.cooperationType;
  },
  companyTypes: (state) => {
    return state.companyTypes;
  },
  description: (state) => {
    return state.description;
  },
  medicalSpecialtyId: (state) => {
    return state.medicalSpecialtyId;
  },
  medicalScientificDegreeId: (state) => {
    return state.medicalScientificDegreeId;
  },
  bankId: (state) => {
    return state.bankId;
  },
  dateOfGraduation: (state) => {
    return state.dateOfGraduation;
  },
  fieldOfStudy: (state) => {
    return state.fieldOfStudy;
  },
  job: (state) => {
    return state.job;
  },
  educationalDegree: (state) => {
    return state.educationalDegree;
  },
  educationalDegreeTypes: (state) => {
    return state.educationalDegreeTypes;
  },
  citizenIdentificationDocument: (state) => {
    return state.citizenIdentificationDocument;
  },
  allFiles: (state) => {
    return state.allFiles;
  },
  filesList: (state) => {
    return state.filesList;
  },
  editedFiles: (state) => {
    return state.editedFiles;
  },
  addedFiles: (state) => {
    return state.addedFiles;
  },
  removalFiles: (state) => {
    return state.removalFiles;
  },
  attachedPayload: (state) => {
    return state.attachedPayload;
  },
  legalFileNumber: (state) => {
    return state.legalFileNumber;
  },
  insuranceNumber: (state) => {
    return state.insuranceNumber;
  },
  userNational: (state) => {
    return state.userNational;
  },
};
